/* =========================================================================
   Countdown timer. Reads the target/end datetimes from the wrapper's
   data attributes (set from section settings), so there is no hard-coded date.
     data-start : ISO datetime the countdown targets (event start)
     data-end   : ISO datetime the event ends (for the "on now / over" message)
   ========================================================================= */
(function () {
  var wraps = document.querySelectorAll("[data-countdown]");
  if (!wraps.length) return;

  wraps.forEach(function (root) {
    var grid = root.querySelector(".countdown");
    var liveEl = root.querySelector(".countdown-live");
    if (!grid) return;

    var start = new Date(root.getAttribute("data-start")).getTime();
    var end = new Date(root.getAttribute("data-end") || root.getAttribute("data-start")).getTime();

    var onMsg = root.getAttribute("data-on-message") || "The show is ON — see you there!";
    var overMsg = root.getAttribute("data-over-message") || "That's a wrap — thanks for coming!";

    var cells = [
      { key: "days", label: root.getAttribute("data-label-days") || "Days" },
      { key: "hours", label: root.getAttribute("data-label-hours") || "Hours" },
      { key: "mins", label: root.getAttribute("data-label-mins") || "Minutes" },
      { key: "secs", label: root.getAttribute("data-label-secs") || "Seconds" },
    ];

    grid.innerHTML = cells
      .map(function (c) {
        return (
          '<div class="count-cell"><div class="num" data-k="' +
          c.key +
          '">--</div><div class="lbl">' +
          c.label +
          "</div></div>"
        );
      })
      .join("");

    var nums = {};
    cells.forEach(function (c) {
      nums[c.key] = grid.querySelector('[data-k="' + c.key + '"]');
    });

    function pad(n) {
      return (n < 10 ? "0" : "") + n;
    }

    var timer;
    function tick() {
      var now = Date.now();
      var diff = start - now;

      if (now >= start && now <= end) {
        if (liveEl) liveEl.textContent = onMsg;
        grid.style.display = "none";
        return;
      }
      if (now > end) {
        if (liveEl) liveEl.textContent = overMsg;
        grid.style.display = "none";
        if (timer) clearInterval(timer);
        return;
      }

      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      s -= d * 86400;
      var h = Math.floor(s / 3600);
      s -= h * 3600;
      var m = Math.floor(s / 60);
      s -= m * 60;

      nums.days.textContent = d;
      nums.hours.textContent = pad(h);
      nums.mins.textContent = pad(m);
      nums.secs.textContent = pad(s);
    }

    tick();
    timer = setInterval(tick, 1000);
  });
})();
